import React from 'react'
import { Modal, useFrontEndEventTrackingService } from '@clickcease/cc-client-components-lib'

import {
  CardSectionWrapper,
  Cards,
  CardImage,
  CardTitle,
  CardSubtitle,
} from './HelpCenterModal.styled'

import { LiveChatIcon } from 'Assets/icons/LiveChatIcon'
import { ScheduleCallIcon } from 'Assets/icons/ScheduleCallIcon'
import { EmailSupportIcon } from 'Assets/icons/EmailSupportIcon'
import { WebinarIcon } from 'Assets/icons/WebinarIcon'

import { useTranslation } from 'react-i18next'
import { useZendeskChat } from 'Hooks/zendesk/useZendeskChat'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { HelpCenterCard } from 'Features/HelpCenterCard/HelpCenterCard'

interface HelpCenterModalProps {
  isOpen?: boolean
  onOpenChange: (a: boolean | number) => void
}

export const HelpCenterModal = ({ isOpen, onOpenChange }: HelpCenterModalProps) => {
  const { t } = useTranslation('helpCenterModal')
  const { openChat } = useZendeskChat()
  const { data: plansDetails } = useGetPlansDetails()
  const { track } = useFrontEndEventTrackingService()

  const sendMixpanelEvent = (cardTitle: string) => {
    track(['segment'], `Clicked ${cardTitle} Card`, {})
  }

  const userIsTrialing = plansDetails?.trial?.active

  return (
    <Modal
      title={t('title')}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      onCloseClick={() => {}}
      style={{ width: '930px', height: '500px', zIndex: 101 }}
    >
      <CardSectionWrapper>
        <Cards
          key={0}
          onClick={() => {
            openChat()
            sendMixpanelEvent(t('cards.live_chat.title'))
          }}
        >
          <CardImage>
            <LiveChatIcon />
          </CardImage>
          <CardTitle>{t('cards.live_chat.title')}</CardTitle>
          <CardSubtitle>{t('cards.live_chat.subtitle')}</CardSubtitle>
        </Cards>

        <HelpCenterCard key={1} />

        <Cards
          key={2}
          onClick={() => {
            window.open(process.env.REACT_APP_CALENDLY_URL, '_blank')
            sendMixpanelEvent(t('cards.schedule_call.title'))
          }}
        >
          <CardImage>
            <ScheduleCallIcon />
          </CardImage>
          <CardTitle>{t('cards.schedule_call.title')}</CardTitle>
          <CardSubtitle>
            {userIsTrialing
              ? t('cards.schedule_call.subtitleTrialing')
              : t('cards.schedule_call.subtitleNotTrialing')}
          </CardSubtitle>
        </Cards>

        <Cards
          key={3}
          onClick={() => {
            window.location.href =
              'mailto:essentials@cheq.ai?subject=Need help with my Cheq Essentials account'
            sendMixpanelEvent(t('cards.email_support.title'))
          }}
        >
          <CardImage>
            <EmailSupportIcon />
          </CardImage>
          <CardTitle>{t('cards.email_support.title')}</CardTitle>
          <CardSubtitle>{t('cards.email_support.subtitle')}</CardSubtitle>
        </Cards>

        <Cards
          key={4}
          onClick={() => {
            window.open(process.env.REACT_APP_WEBINAR_URL, '_blank')
            sendMixpanelEvent(t('cards.webinar.title'))
          }}
        >
          <CardImage>
            <WebinarIcon />
          </CardImage>
          <CardTitle>{t('cards.webinar.title')}</CardTitle>
          <CardSubtitle>{t('cards.webinar.subtitle')}</CardSubtitle>
        </Cards>
      </CardSectionWrapper>
    </Modal>
  )
}
